<template>
  <div>
    <h1>Historial de movimientos</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="3" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="3" class="my-1">
        <b-form-group label-cols-sm="3" label="Tipos de pagos" class="mb-0">
          <b-form-select v-model="paymentType" @change="searchByType(paymentType)" :options="paymentTypes" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getAllCompletedPayments"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
     <template v-slot:cell(status)="row">
        <div :class="statusDictionary[row.item.status].class">{{ statusDictionary[row.item.status].label }}</div>
    </template>
    <template v-slot:cell(newBalance)="row">
          {{ '$' + row.item.newBalance }}
    </template>
    <template v-slot:cell(amount)="row">
          {{ '$' + redondear(row.item.amount) }}
    </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getAllCompletedPayments.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const GET_PENDING_PAYMENTS = gql`
  query getAllPendingPayments{
     getAllPendingPayments{
        pk
        status
        date
        pocketTransactionType
        transactionSource
        reciptEmail
        amount
        createdAt
        name
    }
  }
`
const GET_COMPLETE_TRIPS = gql`
  query getAllCompletedTrips{
     getAllCompletedTrips{
        pk
        name
        status
        date
        transactionSource
        amount
        createdAt
        pocketTransactionType
    }
  }
`
export default {
  data() {
    return {
      getAllCompletedPayments: [],
      fields: [
        { key: 'pk', label: 'ID' },
        { key: 'name', label: 'Responsable' },
        { key: 'reciptEmail', label: 'Correo' },
        { key: 'pocketTransactionType', label: 'Tipo de transacción' },
        { key: 'transactionSource', label: 'Origen de Pago' },
        { key: 'status', label: 'Estado' },
        { key: 'createdAt', label: 'Fecha y hora' },
        { key: 'amount', label: 'Total' },
      ],
      autoRefresh: true,
      statusDictionary: {
        ACCEPTED_COMPLETED: { label: 'Pago exitoso', class: 'text-success font-weight-bold' },
        PENDING: { label: 'Pendiente', class: 'text-warning font-weight-bold' },
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      filter: null,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      paymentTypes: ['Completados', 'Pendientes', 'Comisión'],
      paymentType: null,
    }
  },
  apollo: {
    getAllCompletedPayments: {
      query: gql`query getAllCompletedPayments{
                  getAllCompletedPayments{
                  pk
                  status
                  date
                  pocketTransactionType
                  transactionSource
                  reciptEmail
                  amount
                  newBalance
                  createdAt
                  name
                }
              }
            `,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        console.log(data.getAllCompletedPayments)

        this.totalRows = data.getAllCompletedPayments.length
      },
    },
  },
  methods: {
    onFiltered(filtered) {
      this.totalRows = filtered.length
      this.currentPage = 1
    },
    searchByType(paymentType) {
      if (paymentType === 'Completados' || paymentType === null) {
        // console.log(paymentType)
        this.$apollo.queries.getAllCompletedPayments.skip = false
        this.$apollo.queries.getAllCompletedPayments.refetch()
      } else if (paymentType === 'Pendientes') {
        this.getPendingPayments()
      } else {
        this.getCompleteTrips()
      }
    },
    getPendingPayments() {
      this.$apollo.query({
        query: GET_PENDING_PAYMENTS,
        context: headers(),
      })
        .then(({ data }) => {
          console.log(data)
          this.totalRows = data.getAllPendingPayments.length
          this.$apollo.queries.getAllCompletedPayments.skip = true
          this.getAllCompletedPayments = data.getAllPendingPayments
        })
        .catch(error => {
          this.makeToast(true, 'danger', 'Error', 'Tiempo de espera excedido. Inténtalo más tarde')
          console.log(error)
        })
    },
    getCompleteTrips() {
      this.$apollo.query({
        query: GET_COMPLETE_TRIPS,
        context: headers(),
      })
        .then(({ data }) => {
          console.log(data)
          this.totalRows = data.getAllCompletedTrips.length
          this.$apollo.queries.getAllCompletedPayments.skip = true
          this.getAllCompletedPayments = data.getAllCompletedTrips
        })
        .catch(error => {
          this.makeToast(true, 'danger', 'Error', 'Tiempo de espera excedido. Inténtalo más tarde')
          console.log(error)
        })
    },
    redondear (val) {
      val = Math.round(val * 10) / 10
      var xsd = val.toString().split('.')
      if (xsd.length === 1) {
        val = val.toString() + '.00'
        return val
      }
      return val
    },
  },
}
</script>

<style>

</style>
